import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { OneAttributeResponse, AttributesResponse, SubmitResponse, AttributeValuesResponse, OneAttributeValueResponse, PaginatedAttributeValues, PaginatedAttributeKeys } from '../../models';
import { AttributeInput, AttributeValueInput } from '../../inputs/attribute.input';
import { FilterInput } from '../../inputs';


@Injectable({
  providedIn: 'root'
})
export class AttributeService extends HttpService<
  FilterInput | AttributeInput | AttributeValueInput,
  PaginatedAttributeKeys | PaginatedAttributeValues | AttributesResponse | OneAttributeResponse | AttributeValuesResponse | OneAttributeValueResponse
> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'attribute');
  }

  getAllAttributes(page = 1, limit?: number): Observable<AttributesResponse> {
    return this.getAllPaged('admin', page, '',limit) as Observable<AttributesResponse>;
  }

  getKeyPage(page = 1): Observable<PaginatedAttributeKeys> {
    return this.getAllPaged('admin', page) as Observable<PaginatedAttributeKeys>;
  }

  getValuePage(page = 1): Observable<PaginatedAttributeValues> {
    return this.getAllPaged('value', page) as Observable<PaginatedAttributeValues>;
  }

  findAllKeysByName(text: string, page = 1): Observable<PaginatedAttributeKeys> {
    const filter: FilterInput = {
      page: page,
      limit: 10,
      filters: {
        and: [['attribute_key_translations.name', 'ILIKE', `%${text}%`]]
      }
    };
    return this.filterAllActionPagedAdmin(filter,'admin') as Observable<PaginatedAttributeKeys>;
  }
  
 getAttributeById(id: number|string,value?:string): Observable<OneAttributeResponse> {
    return this.getById(id, 'admin', '', value) as Observable<OneAttributeResponse>;
  }

  createAttribute(attribute: AttributeInput): Observable<SubmitResponse> {
    return this.create(attribute, 'admin');
  }

  updateAttribute(attribute: AttributeInput,id:any): Observable<SubmitResponse> {
    return this.update(attribute,'admin/'+id);
  }

  deleteAttribute(attributeId: number): Observable<SubmitResponse> {
    return this.delete(attributeId,'admin');
  }

  // Attribute Values
  getAllAttributeValues(page = 1): Observable<AttributeValuesResponse> {
    return this.getAllPaged('value', page) as Observable<AttributeValuesResponse>;
  }

  getAttributeValueById(attributeValueId: number): Observable<OneAttributeValueResponse> {
    // done
    return this.getById(attributeValueId, 'admin/value') as Observable<OneAttributeValueResponse>;
  }

  getAttributeValuesByAttributeId(attributeId: any): Observable<AttributeValuesResponse> {
    return this.getById('values','admin/'+attributeId ) as Observable<AttributeValuesResponse>;
  }

  createAttributeValue(attributeValue: AttributeValueInput): Observable<SubmitResponse> {
    return this.create(attributeValue, 'admin/value');
  }

  updateAttributeValue(attributeValue: AttributeValueInput,id:any): Observable<SubmitResponse> {
    return this.update(attributeValue, `admin/value/${id}`);
  }

  deleteAttributeValue(attributeValueId: number): Observable<SubmitResponse> {
    return this.delete(attributeValueId, 'admin/value'); // DELETE /attribute/admin/value/:id
  }

  // Refactored

  getValueBySlugs(slugs: string[]): Observable<PaginatedAttributeValues> {
    const input: FilterInput = {
      page: 1,
      limit: slugs.length,
      filters: {
        and: [['slug', 'in', slugs]]
      }
    };
    return this.filterAllActionPagedAdmin(input, 'value') as Observable<PaginatedAttributeValues>;
  }
//   getAttributeValuesByAttributeIddd(attributeId: number): Observable<AttributeValuesResponse> {
//   const url = `https://api.stargallery.org/api/v1/attribute/${attributeId}/values`;
//   return this.httpClient.get<AttributeValuesResponse>(url);
// }

}
